import { push, ref, set, update } from 'firebase/database';

import { database } from '../../firebase.utils';
import {
  renewTestIDStudentFailed,
  renewTestIDStudentReceived,
  renewTestIDStudentStarted,
} from '../admin/admin.actions';
import {
  addStudentFailed,
  addStudentReceived,
  addStudentStarted,
} from '../coordinator/coordinator.actions';
import { createNotification } from '../notifications/notifications.actions';

const MAXIMUM_REGISTER_TEST_ID_ATTEMPTS = 5;

const registerTestId = async (user, attempt = 0) => {
  let testId =
    Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;

  try {
    await set(push(ref(database, '/test/' + testId)), {
      user: user,
    });
  } catch (e) {
    if (attempt > MAXIMUM_REGISTER_TEST_ID_ATTEMPTS) {
      throw e; // Rethrow exception if attempts exceeded
    }

    await registerTestId(user, attempt + 1);
  }

  return testId;
};

export const createAddStudentHandler =
  (student_data, user_id) => async (dispatch) => {
    dispatch(addStudentStarted());

    try {
      student_data.test_id = await registerTestId(user_id);

      await set(
        push(ref(database, '/koordinator/' + user_id + '/students')),
        student_data
      );
    } catch (error) {
      dispatch(addStudentFailed());
      dispatch(
        createNotification({
          message: `${error.code}: ${error.message}`,
          severity: 'error',
        })
      );

      return;
    }

    dispatch(addStudentReceived());

    dispatch(
      createNotification({
        message: `Žák byl přidán`,
        severity: 'success',
      })
    );
  };

export const createRenewTestIDStudentHandler =
  (cid, sid) => async (dispatch) => {
    dispatch(renewTestIDStudentStarted());

    try {
      let test_id = await registerTestId(cid);

      const updates = {};
      updates['/test_id'] = test_id;
      await update(
        ref(database, '/koordinator/' + cid + '/students/' + sid),
        updates
      );
    } catch (error) {
      dispatch(renewTestIDStudentFailed());
      dispatch(
        createNotification({
          message: `${error.code}: ${error.message}`,
          severity: 'error',
        })
      );

      return;
    }

    dispatch(renewTestIDStudentReceived());

    dispatch(
      createNotification({
        message: `Test ID aktualizovany`,
        severity: 'success',
      })
    );
  };
